<template>
	<span>
		{{text}}
	</span>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

span {
	font-size: 12px;
	font-weight: 300;
	line-height: 10px;
	letter-spacing: 0;

	height: 13px;
	color: get-color($text, 'muted');
	padding-left: 10px;

	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>